function expect<TYPE>(sth: TYPE | null | undefined): TYPE {
    if (sth === null) throw "expected value is null"
    if (sth === undefined) throw "expected value is undefined"
    return sth
}

export default expect
